import { render, staticRenderFns } from "./fileReceiver.vue?vue&type=template&id=091cfc87&scoped=true&"
import script from "./fileReceiver.vue?vue&type=script&lang=js&"
export * from "./fileReceiver.vue?vue&type=script&lang=js&"
import style0 from "./fileReceiver.vue?vue&type=style&index=0&id=091cfc87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091cfc87",
  null
  
)

export default component.exports